import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { initializeTheme, subscribeToSystemTheme } from '@/store';
import '@/styles/index.css';

// Создаем клиент для React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 минут
    },
    mutations: {
      // НЕ повторять мутации: POST-операции (создание заказа, партии и т.п.)
      // неидемпотентны. При retry>0 ответ 5xx, пришедший ПОСЛЕ того как сервер
      // уже закоммитил запись, приводил к повторному запросу и дублю (заказ
      // создавался дважды). Повтор — осознанное действие пользователя.
      retry: 0,
    },
  },
});

// Инициализируем тему
initializeTheme();

// Подписываемся на изменения системной темы
const unsubscribe = subscribeToSystemTheme();

// Очистка при размонтировании (для dev режима)
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    unsubscribe();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--toast-bg, #ffffff)',
            color: 'var(--toast-color, #374151)',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#ffffff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#ffffff',
            },
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>
);
